export default __webpack_public_path__ + "static/banner-how-to-find-the-right-kind-of-personal-loan-87609a6d8aa13db10a0bfcc306d23977.jpg";